import React, { useState, useEffect, useContext } from "react";
import {
  Container,
  TextField,
  Button,
  Typography,
  Box,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
  InputLabel,
  Alert,
  Divider,
  Autocomplete,
  InputAdornment,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import {
  MapContainer,
  TileLayer,
  Marker,
  useMapEvents,
  useMap,
} from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import {
  Badge as BadgeIcon,
  Phone as PhoneIcon,
  Email as EmailIcon,
  ContactEmergency,
  PinDrop as PinDropIcon,
  People as PeopleIcon,
  Person as PersonIcon,
} from "@mui/icons-material";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import { ContextSession } from "../../../services/ContextSession";
import CryptoJS from "crypto-js";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import EventIcon from "@mui/icons-material/Event";
import CancelIcon from "@mui/icons-material/Cancel";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { useNavigate } from "react-router-dom";
import html2pdf from "html2pdf.js";
import imagen from "../../../../src/img/injupemplogogobierno.png";
import PrintIcon from "@mui/icons-material/Print";
import { QRCodeSVG } from "qrcode.react"; // Cambia esta línea
import ReactDOM from "react-dom";

// Configuración íconos Leaflet
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

const containerStyle = {
  width: "100%",
  height: "300px",
};

// Componente para controlar el centro del mapa
const MapController = ({ center, zoom }) => {
  const map = useMap();

  useEffect(() => {
    if (center) {
      map.setView(center, zoom);
    }
  }, [center, zoom, map]);

  return null;
};

const LocationSelector = ({ setLatLng }) => {
  useMapEvents({
    click(e) {
      setLatLng(e.latlng);
    },
  });
  return null;
};

const VerFormularioCitaCallCenterScreen = () => {
  const [form, setForm] = useState({
    identidad: "",
    nombre: "",
    telefono: "",
    constancia: null,
    ubicacion: "",
    enDomicilio: "",
    latLng: null,
    referenciaNombre: "",
    referenciaTelefono: "",
    departamento: null,
    municipio: null,
    tipoCita: "",
    observacion: "",
  });
  const [errores, setErrores] = useState({});
  const [municipiosDisponibles, setMunicipiosDisponibles] = useState([]);
  const [mapCenter, setMapCenter] = useState([14.072275, -87.192136]); // Centro inicial de Honduras
  const [zoomLevel, setZoomLevel] = useState(6);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [errorArchivo, setErrorArchivo] = useState("");
  const [loading, setLoading] = useState(false);
  const [dialogSuccessOpen, setDialogSuccessOpen] = useState(false);
  const [previewUrl, setPreviewUrl] = useState(null);
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  const [filtroDireccion, setFiltroDireccion] = useState("");
  const [buscandoDireccion, setBuscandoDireccion] = useState(false);
  let sessi = useContext(ContextSession);
  const [estadoCita, setEstadoCita] = useState("");
  const [agendarDialogOpen, setAgendarDialogOpen] = useState(false);
  const [fechaSeleccionada, setFechaSeleccionada] = useState(null);
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const navigate = useNavigate();
  const [observacionActual, setObservacionActual] = useState(
    "Se procedió a agendar la cita"
  );
  const [finalizarDialogOpen, setFinalizarDialogOpen] = useState(false);
  const [fechaAgendadaRaw, setFechaAgendadaRaw] = useState(null);
  const [agenteNombre, setAgenteNombre] = useState("Cargando...");
  const [agenteUsuario, setAgenteUsuario] = useState("Cargando...");

  const SolicitudID = sessi.getVariable("VerCitaDomiciliaria");

  useEffect(() => {
    const fetchData = async () => {
      if (!SolicitudID) return;
      setLoading(true);

      try {
        const secretKey =
          "django-insecure-r*+fidc-a5yhm$*h7%2z5k&oly=!1=)3fyyv$tf-k9=qj%55mv";
        const queryString = `id=${SolicitudID}`;
        const signature = CryptoJS.HmacSHA256(
          queryString,
          secretKey
        ).toString();

        const response = await fetch(
          `https://fevida.injupemp.gob.hn:8443/api/Citas/Consultar/?id=${SolicitudID}`,
          {
            headers: {
              "X-Signature": signature,
            },
          }
        );

        if (!response.ok)
          throw new Error("Error al obtener los datos de la cita");

        const data = await response.json();
        const cita = data.Cita || {};
        let base64Constancia = data.ConstanciaMedica;

        // Limpiar el Base64 si viene como string JSON
        if (
          base64Constancia &&
          base64Constancia.startsWith('"') &&
          base64Constancia.endsWith('"')
        ) {
          base64Constancia = base64Constancia.slice(1, -1);
        }

        let latLng = null;
        if (cita.ubicacion) {
          const [lat, lng] = cita.ubicacion.split(",").map(parseFloat);
          latLng = { lat, lng };
          setMapCenter([lat, lng]);
          setZoomLevel(16);
        }

        // Convertir base64 a URL para vista previa
        let preview = null;
        if (base64Constancia) {
          // Primero intentamos determinar si es PDF o imagen
          const isPdf = base64Constancia.startsWith("JVBERi0"); // Cabecera PDF en Base64
          const mimeType = isPdf ? "application/pdf" : "image/jpeg"; // Ajusta según tus necesidades

          preview = `data:${mimeType};base64,${base64Constancia}`;
        }

        setForm({
          identidad: cita.DNI || "",
          nombre: cita.nombre || "",
          telefono: cita.celular?.replace(/^504/, "") || "",
          constancia: null,
          ubicacion: cita.direccion || "",
          enDomicilio: "",
          latLng: latLng,
          referenciaNombre: cita.nombreReferencia || "",
          referenciaTelefono:
            cita.telefonoReferencia?.replace(/^504/, "") || "",
          departamento: null,
          municipio: null,
          tipoCita: cita.tipoCita || "",
          observacion: cita.observacionParticipante || "",
        });
        setEstadoCita(cita.estado || "");
        setFechaAgendadaRaw(cita.fechaAgendada || null);
        setPreviewUrl(preview);

        const idAgendo = cita.usuarioAgendoId;
        // if (idAgendo && sessi.sessionData.token) {
        //     try {
        //         const userResponse = await fetch(
        //             "https://bei360.injupemp.gob.hn:8444/api/auth/list",
        //             {
        //                 headers: {
        //                     Authorization: `Bearer ${sessi.sessionData.token}`,
        //                 },
        //             }
        //         );
        //         const users = await userResponse.json();
        //         const found = Array.isArray(users)
        //             ? users.find(u => u.id === idAgendo)
        //             : null;
        //         setAgenteUsuario(found ? found.username : 'N/D');
        //         setAgenteNombre(found ? found.first_name + ' ' + found.last_name : 'N/D');
        //     } catch (err) {
        //         setAgenteNombre('N/D');
        //         setAgenteUsuario('N/D');
        //     }
        // }
      } catch (error) {
        console.error("Error al cargar datos:", error);
        setPreviewUrl(null); // Asegurarse de limpiar en caso de error
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [SolicitudID]);

  const handlePrint = () => {
    const fechaAgendadaFormateada = fechaAgendadaRaw
      ? new Date(fechaAgendadaRaw).toLocaleDateString()
      : "Pendiente";

    // Generar URL de Google Maps si hay ubicación
    const googleMapsUrl = form.latLng
      ? `https://www.google.com/maps?q=${form.latLng.lat},${form.latLng.lng}`
      : null;

    // Crear un elemento div temporal para renderizar el QR
    const qrContainer = document.createElement("div");
    if (googleMapsUrl) {
      ReactDOM.render(
        <QRCodeSVG
          value={googleMapsUrl}
          size={120} // Tamaño un poco más pequeño
          level="H"
          includeMargin={true}
        />,
        qrContainer
      );
    }

    const contentHTML = `
  <div style="
      font-family: Arial, sans-serif;
      background: #fff;
      border-radius: 14px;
      box-shadow: 0 4px 16px #0002;
      padding: 24px 26px 16px 26px;
      width: 740px;
      margin: 0 auto;
      box-sizing: border-box;
      position: relative;
      min-width: 740px;
      max-width: 740px;
      font-size: 13.5px;
      line-height: 1.23;
      overflow: hidden;
      page-break-inside: avoid;
    ">

    <!-- Encabezado -->
    <div style="text-align: center; border-bottom: 2.5px solid #CDCDCD; padding-bottom: 10px; margin-bottom: 13px;">
      <img src="${imagen}" alt="Logo Injupemp" style="max-width: 200px; margin-bottom: 6px;"/>
      <div style="background: #e0f2fe; padding: 4.5px 0; font-size: 1.5em; border-radius: 4px; margin-bottom: 2.5px; font-weight: bold;">INJUPEMP - Prueba de Sobrevivencia 2025</div>
      <h2 style="margin: 5px 0 2px 0; font-size: 1.5em;">Solicitud Visita Domiciliaria</h2>
      <div style="margin-top: 3.5px; font-size: 1em; color: #333;"><strong>ID Solicitud:</strong> ${SolicitudID}</div>
    </div>

    <!-- Estado y Fecha -->
    <div style="text-align: center; margin-bottom: 13px;">
      <span style="display: inline-block; background: #e0f2fe; color: #155fa0; padding: 4px 16px; font-weight: bold; font-size: 1.3em; border-radius: 7px; border: 1px solid #b6dbf7;">
        Estado: ${estadoCita}
      </span>
      ${
        estadoCita === "Agendada"
          ? `<div style="margin-top: 4px; font-size: 1.3em; color: #444;"><strong>Fecha Agendada:</strong> ${fechaAgendadaFormateada}</div>`
          : ""
      }
    </div>

    <!-- Datos personales -->
    <div style="margin-bottom: 10px;">
      <div style="display: flex; align-items: center; background: #f1f5f9; border-radius: 4px 4px 0 0; padding: 5px 10px;">
        <span style="font-size: 1.08em; margin-right: 6px;">👤</span>
        <h3 style="margin: 0; font-size: 1.3em;">Datos del Jubilado/Pensionado</h3>
      </div>
      <table style="width: 100%; border-collapse: collapse; font-size: 0.98em; page-break-inside: avoid;">
        <thead>
          <tr style="background-color: #e2e8f0;">
            <th style="border: 1px solid #cbd5e1; padding: 6px 4px; font-weight: bold;">Nombre</th>
            <th style="border: 1px solid #cbd5e1; padding: 6px 4px; font-weight: bold;">Identidad</th>
            <th style="border: 1px solid #cbd5e1; padding: 6px 4px; font-weight: bold;">Teléfono</th>
          </tr>
        </thead>
        <tbody>
          <tr style="background-color: #f8fafc;">
            <td style="border: 1px solid #cbd5e1; padding: 6px 4px; text-align: center;">${
              form.nombre
            }</td>
            <td style="border: 1px solid #cbd5e1; padding: 6px 4px; text-align: center;">${
              form.identidad
            }</td>
            <td style="border: 1px solid #cbd5e1; padding: 6px 4px; text-align: center;">${
              form.telefono
            }</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Dirección -->
    <div style="margin-bottom: 10px;">
      <div style="display: flex; align-items: center; background: #f1f5f9; border-radius: 4px 4px 0 0; padding: 5px 10px;">
        <span style="font-size: 1.06em; margin-right: 6px;">📍</span>
        <h3 style="margin: 0; font-size: 1.3em;">Ubicación Reportada</h3>
      </div>
      <p style="padding: 8px 12px 5px 13px; margin: 0; font-size: 1em; background: #f9fafb; border-radius: 0 0 4px 4px; border: 1px solid #e5e7eb; border-top: none;">
        ${form.ubicacion || "No especificada"}
      </p>
    </div>

    <!-- Referencia -->
    <div style="margin-bottom: 10px;">
      <div style="display: flex; align-items: center; background: #f1f5f9; border-radius: 4px 4px 0 0; padding: 5px 10px;">
        <span style="font-size: 1.06em; margin-right: 6px;">☎️</span>
        <h3 style="margin: 0; font-size: 1.3em;">Referencia Personal</h3>
      </div>
      <div style="padding: 8px 12px 5px 13px; background: #f9fafb; border-radius: 0 0 4px 4px; border: 1px solid #e5e7eb; border-top: none;">
        <strong>Nombre:</strong> ${form.referenciaNombre || "N/D"}<br/>
        <strong>Teléfono:</strong> ${form.referenciaTelefono || "N/D"}
      </div>
    </div>

    <!-- Agente Agendó -->
    ${
      estadoCita === "Agendada"
        ? `
        <div style="margin-bottom: 10px;">
          <div style="display: flex; align-items: center; background: #f1f5f9; border-radius: 4px 4px 0 0; padding: 5px 10px;">
            <span style="font-size: 1.05em; margin-right: 6px;">🧑‍💼</span>
            <h3 style="margin: 0; font-size: 1.3em;">Agente Que Agendó La Cita</h3>
          </div>
          <div style="padding: 8px 12px 5px 13px; background: #f9fafb; border-radius: 0 0 4px 4px; border: 1px solid #e5e7eb; border-top: none;">
            <strong>Nombre:</strong> ${agenteNombre || "N/D"}<br/>
            <strong>Usuario:</strong> ${agenteUsuario || "N/D"}
          </div>
        </div>
      `
        : ""
    }
    ${
      googleMapsUrl
        ? `
      <div>
        <div style="text-align: center; background: #f8fafc; padding: 8px 4px 4px 4px; border: 1.5px solid #cbd5e1; border-radius: 8px;">
          <div style="font-size: 20px; margin-bottom: 1.5px; font-weight: bold;">UBICACIÓN</div>
          ${qrContainer.innerHTML}
          <div style="font-size: 14px; margin-top: 1.5px; color: #64748b;">Escanea para ver el mapa</div>
        </div>
      </div>
    `
        : ""
    }
    <!-- Pie de página -->
    <div style="text-align: right; font-size: 0.92em; color: #64748b; margin-top: 20px;">
      <div>Generado automáticamente el ${new Date().toLocaleDateString()}</div>
      <div>INJUPEMP 360</div>
    </div>
  </div>
`;

    const element = document.createElement("div");
    element.innerHTML = contentHTML;

    const options = {
      margin: 0.5,
      filename: `Solicitud_Visita_${SolicitudID}.pdf`,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
    };

    html2pdf().set(options).from(element).save();
  };

  return (
    <>
      <Container maxWidth="lg" style={{ marginTop: 20 }} id="printableArea">
        <Typography
          variant="h5"
          align="center"
          gutterBottom
          fontWeight={"bold"}
        >
          Agendar Visita Domiciliaria - Prueba Sobrevivencia 2025 {SolicitudID}
        </Typography>

        {estadoCita && (
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            mt={1}
          >
            <Typography
              variant="subtitle1"
              fontWeight="bold"
              sx={{
                color:
                  estadoCita === "Solicitada"
                    ? "orange"
                    : estadoCita === "Agendada"
                    ? "green"
                    : "red",
              }}
            >
              Estado: {estadoCita}
              {estadoCita === "Agendada" && fechaAgendadaRaw && (
                <span style={{ fontWeight: "normal", marginLeft: 8 }}>
                  (Fecha: {new Date(fechaAgendadaRaw).toLocaleDateString()})
                </span>
              )}
            </Typography>
          </Box>
        )}

        <Box display="flex" mt={1}>
          <Typography variant="h5" fontWeight="bold">
            Tipo de Cita Solicitada: {form.tipoCita || "No especificado"}
          </Typography>
        </Box>
        <Divider sx={{ my: 2 }} />
        <Typography variant="h5" gutterBottom fontWeight={"bold"}>
          Datos Personales del Jubilado/Pensionado
        </Typography>
        <TextField
          fullWidth
          label="Número de Identidad"
          name="identidad"
          value={form.identidad}
          inputProps={{ maxLength: 13 }}
          margin="normal"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <ContactEmergency />
              </InputAdornment>
            ),
          }}
        />

        <TextField
          fullWidth
          label="Nombre Completo"
          name="nombre"
          value={form.nombre}
          margin="normal"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <PersonIcon />
              </InputAdornment>
            ),
          }}
        />

        <TextField
          fullWidth
          label="Número de Teléfono"
          name="telefono"
          value={form.telefono}
          inputProps={{ maxLength: 8 }}
          margin="normal"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <PhoneIcon />
              </InputAdornment>
            ),
          }}
        />

        {previewUrl && (
          <Box mt={3}>
            <Typography variant="h5" gutterBottom fontWeight={"bold"}>
              Constancia Médica
            </Typography>

            {form.constancia && (
              <Typography mt={1} variant="body2" color="textSecondary">
                Archivo seleccionado: <strong>{form.constancia.name}</strong>
              </Typography>
            )}

            {errorArchivo && (
              <Alert severity="error" sx={{ mt: 1 }}>
                {errorArchivo}
              </Alert>
            )}

            {previewUrl && (
              <Box
                mt={2}
                sx={{
                  border: "1px solid #ccc",
                  borderRadius: 2,
                  overflow: "hidden",
                  width: "100%",
                  mx: "auto",
                }}
              >
                {previewUrl.includes("application/pdf") ? (
                  <iframe
                    src={previewUrl}
                    title="Vista previa de la constancia médica"
                    width="100%"
                    height="700px"
                    style={{ border: "none" }}
                    onError={(e) => {
                      console.error("Error al cargar el PDF");
                      e.target.style.display = "none";
                      // Mostrar mensaje alternativo si falla
                    }}
                  />
                ) : (
                  <img
                    src={previewUrl}
                    alt="Constancia médica"
                    style={{ width: "100%", height: "auto", display: "block" }}
                    onError={(e) => {
                      console.error("Error al cargar la imagen");
                      e.target.style.display = "none";
                      // Mostrar mensaje alternativo si falla
                    }}
                  />
                )}
                {!previewUrl && (
                  <Typography
                    variant="body2"
                    color="error"
                    align="center"
                    py={2}
                  >
                    Error, no se pudo cargar el documento
                  </Typography>
                )}
              </Box>
            )}
          </Box>
        )}
        <Divider sx={{ my: 3 }} />
        <Typography variant="h5" fontWeight={"bold"} gutterBottom>
          Dirección
        </Typography>

        {form.latLng && (
          <Box sx={{ mt: 2, position: "relative" }}>
            <MapContainer
              center={mapCenter}
              zoom={zoomLevel}
              style={containerStyle}
              key={`${mapCenter[0]}-${mapCenter[1]}-${zoomLevel}`}
            >
              <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
              {form.latLng && (
                <Marker position={[form.latLng.lat, form.latLng.lng]} />
              )}
              {form.enDomicilio === "No" && (
                <LocationSelector
                  setLatLng={(latlng) => {
                    setForm({ ...form, latLng: latlng });
                    setMapCenter([latlng.lat, latlng.lng]);
                    setZoomLevel(16);
                  }}
                />
              )}
              <MapController center={mapCenter} zoom={zoomLevel} />
            </MapContainer>

            {/** Backdrop solo sobre el mapa */}
            <Backdrop
              sx={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                zIndex: 10,
                color: "#fff",
              }}
              open={buscandoDireccion}
            >
              <CircularProgress color="inherit" />
            </Backdrop>
          </Box>
        )}

        <TextField
          fullWidth
          label="Ubicación (Barrio/Colonia y Referencia)"
          name="ubicacion"
          value={form.ubicacion}
          margin="normal"
          placeholder="Ejemplo: Colonia Miraflores, Avenida Principal 3 cuadra arriba de Farmacia Más, Casa color amarillo"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <PinDropIcon />
              </InputAdornment>
            ),
          }}
        />

        <Divider sx={{ my: 3 }} />
        <Typography variant="h5" fontWeight={"bold"} gutterBottom>
          Referencia Personal
        </Typography>
        <TextField
          fullWidth
          label="Referencia Personal (Nombre)"
          name="referenciaNombre"
          value={form.referenciaNombre}
          margin="normal"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <PeopleIcon />
              </InputAdornment>
            ),
          }}
        />

        <TextField
          fullWidth
          label="Teléfono Referencia Personal"
          name="referenciaTelefono"
          value={form.referenciaTelefono}
          inputProps={{ maxLength: 8 }}
          margin="normal"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <PhoneIcon />
              </InputAdornment>
            ),
          }}
        />

        <Divider sx={{ my: 3 }} />
        <Typography variant="h5" fontWeight={"bold"} gutterBottom>
          Observación
        </Typography>
        <TextField
          fullWidth
          multiline
          rows={4}
          label="Observación"
          name="observacion"
          value={form.observacion}
          margin="normal"
        />
      </Container>
      <Dialog
        open={agendarDialogOpen}
        onClose={() => setAgendarDialogOpen(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>
          <Box display="flex" alignItems="center" gap={1}>
            <EventIcon />
            <Typography variant="h6">Agendar Cita</Typography>
          </Box>
        </DialogTitle>
        <DialogContent dividers>
          <Typography gutterBottom>
            Seleccione la fecha para agendar la cita:
          </Typography>
          <TextField
            type="date"
            label="Fecha de Cita"
            fullWidth
            required
            margin="dense"
            InputLabelProps={{ shrink: true }}
            value={fechaSeleccionada || ""}
            onChange={(e) => setFechaSeleccionada(e.target.value)}
            inputProps={{
              min: new Date().toISOString().split("T")[0],
            }}
            error={!fechaSeleccionada}
            helperText={!fechaSeleccionada ? "Debe seleccionar una fecha" : ""}
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setAgendarDialogOpen(false)}
            startIcon={<CancelIcon />}
            variant="outlined"
            color="error"
          >
            Cancelar
          </Button>
          <Button
            onClick={() => {
              setAgendarDialogOpen(false);
              setConfirmDialogOpen(true);
            }}
            startIcon={<CalendarMonthIcon />}
            variant="contained"
            color="primary"
            disabled={!fechaSeleccionada}
          >
            Agendar
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={confirmDialogOpen}
        onClose={() => setConfirmDialogOpen(false)}
      >
        <DialogTitle>Confirmar Visita Domiciliaria</DialogTitle>
        <DialogContent>
          <Typography>
            ¿Está seguro de agendar la cita del Jubilado/Pensionado{" "}
            <strong>{form.nombre}</strong> para la fecha{" "}
            <strong>{fechaSeleccionada}</strong>?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmDialogOpen(false)} color="error">
            No
          </Button>
          <Button
            onClick={async () => {
              setConfirmDialogOpen(false);
              setLoading(true);

              try {
                const url =
                  "https://fevida.injupemp.gob.hn:8443/api/Citas/Actualizar/";
                const secretKey =
                  "django-insecure-r*+fidc-a5yhm$*h7%2z5k&oly=!1=)3fyyv$tf-k9=qj%55mv";
                const queryString = `id=${SolicitudID}`;
                const signature = CryptoJS.HmacSHA256(
                  queryString,
                  secretKey
                ).toString();

                const formData = new FormData();
                formData.append("id", SolicitudID);
                formData.append("estado", "Agendada");
                formData.append("observacionOficial", observacionActual);
                formData.append(
                  "fechaAgendada",
                  `${fechaSeleccionada}T14:00:00`
                );
                formData.append("usuarioAgendoId", sessi.sessionData.id);

                const response = await fetch(url, {
                  method: "PATCH",
                  headers: {
                    "X-Signature": signature,
                  },
                  body: formData,
                });

                if (!response.ok) throw new Error("Error al agendar la cita");

                setDialogSuccessOpen(true);
              } catch (error) {
                console.error("Error al agendar cita:", error);
                alert(
                  "Hubo un problema al agendar la cita. Intente nuevamente."
                );
              } finally {
                setLoading(false);
              }
            }}
            variant="contained"
            color="primary"
          >
            Sí
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={dialogSuccessOpen} onClose={() => {}} disableEscapeKeyDown>
        <DialogTitle>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center" // Centrado horizontal
            gap={1}
          >
            <Typography variant="h6">Cita Agendada con Éxito</Typography>
            <CheckCircleIcon color="success" />
          </Box>
        </DialogTitle>

        <DialogContent>
          <Typography textAlign={"justify"}>
            La visita domiciliaria fue agendada correctamente.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Box display="flex" justifyContent="center" width="100%">
            <Button
              variant="contained"
              color="success"
              onClick={() => {
                setDialogSuccessOpen(false);
                navigate("/Sociales/ListaVisitasDomiciliarias", {
                  replace: true,
                });
              }}
            >
              Aceptar
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
      <Dialog
        open={finalizarDialogOpen}
        onClose={() => setFinalizarDialogOpen(false)}
      >
        <DialogTitle>Finalizar Visita Domiciliaria</DialogTitle>
        <DialogContent>
          <Typography>
            ¿Está seguro de finalizar la cita del jubilado/pensionado{" "}
            <strong>{form.nombre}</strong>?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setFinalizarDialogOpen(false)} color="error">
            No
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={async () => {
              setFinalizarDialogOpen(false);
              setLoading(true);

              try {
                const url =
                  "https://fevida.injupemp.gob.hn:8443/api/Citas/Actualizar/";
                const secretKey =
                  "django-insecure-r*+fidc-a5yhm$*h7%2z5k&oly=!1=)3fyyv$tf-k9=qj%55mv";
                const queryString = `id=${SolicitudID}`;
                const signature = CryptoJS.HmacSHA256(
                  queryString,
                  secretKey
                ).toString();

                const formData = new FormData();
                formData.append("id", SolicitudID);
                formData.append("estado", "Finalizada");
                formData.append(
                  "observacionOficial",
                  "Se procedió a Finalizar la cita"
                );
                formData.append("usuarioAgendoId", sessi.sessionData.id);
                formData.append(
                  "fechaAgendada",
                  `${
                    fechaSeleccionada || new Date().toISOString().split("T")[0]
                  }T14:00:00`
                );

                const response = await fetch(url, {
                  method: "PATCH",
                  headers: {
                    "X-Signature": signature,
                  },
                  body: formData,
                });

                if (!response.ok) throw new Error("Error al finalizar la cita");

                setDialogSuccessOpen(true);
              } catch (error) {
                console.error("Error al finalizar cita:", error);
                alert("Hubo un problema al finalizar la cita.");
              } finally {
                setLoading(false);
              }
            }}
          >
            Sí
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default VerFormularioCitaCallCenterScreen;
